interface PaginationProps {
  total: number;
  pageSize: number;
  visible: number;
  onChangeVisible: (visible: number) => void;
}

export default function Pagination({ total, pageSize, visible, onChangeVisible }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(totalPages, Math.ceil(visible / pageSize));

  if (total <= pageSize) return null;

  const goTo = (page: number) => {
    const target = Math.min(totalPages, Math.max(1, page));
    onChangeVisible(target * pageSize);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="mt-8 flex flex-col items-center gap-4">
      <div className="hidden md:flex items-center gap-2">
        <button
          type="button"
          onClick={() => goTo(currentPage - 1)}
          disabled={currentPage === 1}
          className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-s-line text-lg"></i>
        </button>
        {pages.map((page) => (
          <button
            key={page}
            type="button"
            onClick={() => goTo(page)}
            className={`w-9 h-9 flex items-center justify-center rounded-md text-sm cursor-pointer transition-colors ${
              page === currentPage
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
            }`}
          >
            {page}
          </button>
        ))}
        <button
          type="button"
          onClick={() => goTo(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors"
        >
          <i className="ri-arrow-right-s-line text-lg"></i>
        </button>
      </div>

      <div className="md:hidden w-full">
        {visible < total ? (
          <button
            type="button"
            onClick={() => onChangeVisible(visible + pageSize)}
            className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-medium cursor-pointer transition-colors"
          >
            <i className="ri-add-line"></i>
            加载更多
          </button>
        ) : (
          <p className="text-center text-sm text-foreground-500 py-2">已经到底啦，没有更多作品了</p>
        )}
      </div>
    </div>
  );
}